<div class="actions-wrapper">
  <qm-element-actions
    *ngIf="currentFeature"
    [selectedFeature]="currentFeature"
    [selectedLayer]="currentFeature.layer"
    [visibleButtons]="{info: false, flag: true, focus: true, follow: false}">
  </qm-element-actions>
</div>
<qm-element-timeline [currentFeature]="currentFeature"></qm-element-timeline>
